module.exports = __webpack_public_path__ + "img/artrockopiya_kyoniga.28119c71.png";